var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[_c('a-card',{attrs:{"bordered":false}},[_c('div',{staticClass:"dis_flex"},[_c('a-icon',{staticClass:"btn_back",attrs:{"type":"left-circle","theme":"twoTone"},on:{"click":function($event){return _vm.$router.go(-1)}}}),_c('h2',{staticClass:"title_from"},[_vm._v(_vm._s(_vm.formTitle))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }